<via-error>
  <p>
    {{ "errors.forbidden.title" | transloco }}
  </p>

  <via-back-to-dashboard-button>
    {{ "button.home" | transloco }}
  </via-back-to-dashboard-button>
</via-error>
